export default "__VITE_ASSET__BuleBNxF__"